import { Skeleton, cn } from '@ai-tutor/ui';

/**
 * Holds a concept visual's place while it is being drawn (the compact
 * picture height), so the text around it is readable now and does not move
 * much when the visual lands. `label` names what is coming, for screen
 * readers and under the skeleton.
 */
export function VisualPlaceholder({
  label,
  className,
}: {
  label?: string;
  className?: string;
}) {
  const what = label ? `Drawing: ${label}` : 'Drawing the visual';
  return (
    <div
      role='status'
      aria-label={`${what}, on its way`}
      className={cn(className)}
    >
      <Skeleton
        className='h-40 w-full rounded-lg'
        data-testid='concept-visual-placeholder'
      />
      <p className='mt-1.5 text-xs text-muted-foreground'>{what}…</p>
    </div>
  );
}
